import React from "react";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
const SocialButton = ({ getresume }) => {
  return (
    <>
      <aside
        aria-label="connect"
        className=" absolute group flex-col z-40 duration-500 hidden md:flex top-[500%]  left-0"
      >
        <ul
          aria-label="social link"
          className="md:-space-y-16 hover:-space-y-2"
        >
          <li aria-label="Linkedin" className="outline-none sociali ">
            <span className=" socaila text-cyan-900 bg-cyan-300/50">
              <a
                href="https://www.Linkedin.com/in/itiwariarun"
                id="linkedin page"
                rel="exteranl noreferrer noopener"
                title="linkedin page"
                target="_blank"
              >
                {" "}
                Linkedin
              </a>
              <FaLinkedin aria-label="Linkedin" size={30} />
            </span>
          </li>

          <li aria-label="github" className="outline-none sociali">
            <span className=" socaila bg-inherit text-slate-800 hover:bg-slate-400/60">
              <a
                className=""
                href="https://www.github.com/itiwariarun"
                id="github page"
                rel="exteranl noreferrer noopener"
                title="github page"
                target="_blank"
              >
                Github
              </a>
              <FaGithub aria-label="github" size={30} />
            </span>
          </li>
          <li aria-label="instagram" className="outline-none sociali">
            <span className=" instagram socaila">
              <a
                href="https://www.instagram.com/itiwariarun/?igshid=YmMyMTA2M2Y%3D"
                id="instagram page"
                rel="exteranl noreferrer noopener"
                title="instagram page"
                target="_blank"
              >
                Instagram
              </a>
              <FaInstagram
                aria-label="instagram"
                size={30}
                className="rounded-lg "
              />
            </span>
          </li>

          <li aria-label="mail" className="outline-none sociali">
            <span className="text-teal-900 socaila bg-blue-300/50">
              <a href="mailto: itiwariarun438@gmail.com"> Mail</a>
              <HiOutlineMail aria-label="mail" size={30} />
            </span>
          </li>
          <li aria-label="resume" className="outline-none sociali">
            <span className="duration-1000 text-slate-800 socaila bg-slate-500 group-hover:bg-gray-500/30">
              <button
                aria-label="resume"
                type="button"
                className="active:outline-none"
                onClick={getresume}
              >
                Resume
              </button>
              <BsFillPersonLinesFill
                size={30}
                aria-label="resume"
                name="resume"
                className="duration-1000 group-hover:text-red-900"
              />
            </span>
          </li>
        </ul>
      </aside>
    </>
  );
};

export default SocialButton;
